/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const gray: QtmColor = {
  50: '#F9F9F6',
  100: '#F2F2EF',
  200: '#E9E9E6',
  300: '#D9D9D6' /* light */,
  400: '#B5B5B2',
  500: '#959593',
  600: '#6D6D6A',
  700: '#595957' /* primary */,
  800: '#3B3B39' /* dark */,
  900: '#1B1B19',
  A100: '#C1C1C1',
  A200: '#AAAAAA',
  A700: '#6B6B6B',
  A800: '#333',
  A900: '#212121',
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.black,
    500: common.black,
    600: common.white,
    700: common.white,
    800: common.white,
    900: common.white,
    A100: common.black,
    A200: common.black,
    A700: common.white,
    A800: common.white,
    A900: common.white,
  },
};

export default gray;
